import { X } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button } from '../atoms';

interface PopupHeaderProps {
  titleId: string;
  title: string;
  description?: ReactNode;
  onClose: () => void;
}

/** Title row at the top of a popup, with the close action. */
export function PopupHeader({ titleId, title, description, onClose }: PopupHeaderProps) {
  return (
    <div className="flex items-start justify-between gap-4 border-b border-line px-5 py-4">
      <div className="flex min-w-0 flex-col gap-1">
        <h2 id={titleId} className="text-fg">
          {title}
        </h2>
        {description && <p className="text-[13px] text-fg-muted">{description}</p>}
      </div>
      <Button variant="ghost" size="icon" onClick={onClose} aria-label="Close" icon={<X size={16} aria-hidden />} />
    </div>
  );
}
